export default {
    userHasGivenMapboxConsent(state) {
        state.consentGiven = true
    },
}
